import React from 'react';
import { useSelector } from 'react-redux';

import {
  areRescheduleClassesAppliedFiltersPresentSelector,
  rescheduleErrorsSelector,
  sbatGroupListSelector,
} from 'features/classCreation';
import CreateNewScheduleButton from '../CreateNewScheduleButton';
import ErrorLayout from 'components/ErrorLayout';
import Field from 'components/Field';
import NewScheduleSelect from '../NewScheduleSelect';
import NewScheduleStartDateInput from '../NewScheduleStartDateInput';
import RescheduleClassesTable from '../RescheduleClassesTable';
import styles from './RescheduleDetails.module.scss';

function RescheduleDetails() {
  const errors = useSelector(rescheduleErrorsSelector);
  const areFiltersApplied = useSelector(
    areRescheduleClassesAppliedFiltersPresentSelector
  );
  const sbatGroups = useSelector(sbatGroupListSelector);
  const sbatGroupsCount = sbatGroups.length;

  if (sbatGroupsCount > 0) {
    return (
      <div className={styles.root}>
        <Field
          clientErrors={errors}
          label={
            areFiltersApplied
              ? `Results for lectures (${sbatGroupsCount})`
              : 'Lectures'
          }
          name="lectures"
        >
          <RescheduleClassesTable sbatGroups={sbatGroups} />
        </Field>
        <Field
          clientErrors={errors}
          label="New schedule for above lectures"
          name="schedule"
        >
          <div className={styles.scheduleFieldGroup}>
            <NewScheduleSelect />
            <NewScheduleStartDateInput />
          </div>
        </Field>
        <CreateNewScheduleButton />
        <div className="italic m-t-xxs">
          The New Schedule will be applied to all above lectures
        </div>
      </div>
    );
  } else {
    return (
      <ErrorLayout
        message="No upcoming classes are there!"
        className="bold"
      />
    );
  }
}

export default RescheduleDetails;
